import POVBlock from "../POVBlock/POVBlock";
import Quote from "../Quote/Quote";
import Insight from "../Insight/Insight";
import POVItem from '../POVItem/POVItem';
import FooterCta from "../FooterCta/FooterCta";

class ErgDetail {
  constructor(contentfulNode, globalErgReference) {
    this.ergTitle = contentfulNode?.ergTitle || globalErgReference?.ergTitle;
    this.ergLabel = contentfulNode?.ergLabel || globalErgReference?.ergLabel;
    this.ergBody = contentfulNode?.ergBody || globalErgReference?.ergBody;
    this.snippet = contentfulNode?.snippet?.snippet || globalErgReference?.snippet?.snippet;
    this.slug = contentfulNode?.slug || globalErgReference?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug || globalErgReference?.localizationSlug;
    this.ergHeroImages = contentfulNode?.ergHeroImages || globalErgReference?.ergHeroImages;
    this.quoteSlider = contentfulNode?.quoteSlider
      ? contentfulNode?.quoteSlider.map(quote => new Quote(quote))
      : globalErgReference?.quoteSlider
      ? globalErgReference?.quoteSlider.map(quote => new Quote(quote))
      : null;
    this.ourObjectivesTitle = contentfulNode?.ourObjectivesTitle || globalErgReference?.ourObjectivesTitle;
    this.ourObjectivesBody = contentfulNode?.ourObjectivesBody || globalErgReference?.ourObjectivesBody;
    this.ourObjectivesTiles = contentfulNode?.ourObjectivesTiles
      ? contentfulNode?.ourObjectivesTiles.map(povItem => new POVItem(povItem))
      : globalErgReference?.ourObjectivesTiles
      ? globalErgReference?.ourObjectivesTiles.map(povItem => new POVItem(povItem))
      : null;
    this.whyItMatters = contentfulNode?.whyItMatters
      ? new POVBlock(contentfulNode?.whyItMatters)
      : globalErgReference?.whyItMatters
      ? new POVBlock(globalErgReference?.whyItMatters)
      : null;
    this.featuredContent = contentfulNode?.featuredContent || globalErgReference?.featuredContent;
    this.seeTheDifferenceLabel = 'See The Difference';
    this.seeTheDifferenceTitle = contentfulNode?.seeTheDifferenceTitle || globalErgReference?.seeTheDifferenceTitle;
    this.seeTheDifferenceBody = contentfulNode?.seeTheDifferenceBody || globalErgReference?.seeTheDifferenceBody;
    this.seeTheDifferenceVideo = contentfulNode?.seeTheDifferenceVideo || globalErgReference?.seeTheDifferenceVideo;
    this.editorialSection = contentfulNode?.editorialSection
      ? contentfulNode?.editorialSection.map(section => new POVBlock(section))
      : globalErgReference?.editorialSection
      ? globalErgReference?.editorialSection.map(section => new POVBlock(section))
      : null;
    this.featuredQuote = contentfulNode?.featuredQuote
      ? new Quote(contentfulNode?.featuredQuote)
      : globalErgReference?.featuredQuote
      ? new Quote(globalErgReference?.featuredQuote)
      : null;
    this.awardsLabel = contentfulNode?.awardsLabel || globalErgReference?.awardsLabel;
    this.awardsTitle = contentfulNode?.awardsTitle || globalErgReference?.awardsTitle;
    this.awardsBody = contentfulNode?.awardsBody || globalErgReference?.awardsBody;
    this.awardsIcons = {
      gridItems: contentfulNode?.awardsIcons || globalErgReference?.awardsIcons
    };
    this.relatedInsights = contentfulNode?.relatedInsights
      ? contentfulNode?.relatedInsights.map(insight => new Insight(insight))
      : globalErgReference?.relatedInsights
      ? globalErgReference?.relatedInsights.map(insight => new Insight(insight))
      : null;
    this.expertsLabel = contentfulNode?.expertsLabel || globalErgReference?.expertsLabel;
    this.expertsTitle = contentfulNode?.expertsTitle || globalErgReference?.expertsTitle;
    this.expertsBody = contentfulNode?.expertsBody || globalErgReference?.expertsBody;
    this.footerCta = contentfulNode?.footerCta
      ? new FooterCta(contentfulNode.footerCta)
      : globalErgReference?.footerCta
      ? new FooterCta(globalErgReference.footerCta)
      : null;
  }
}

export default ErgDetail;
